import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/vtwin_tires.jpg")